let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9E19j")).then(() => parcelRequire('f85Xb'));